/**
 * This listener is used to show the refresh page modal when the user navigates back to the page.
 * This fixes an issue where the data is not re-fetched when the user navigates back to the application
 *  using "back" button from Stripe after its link expired (amount changed and/or took too long).
 * @see https://helpdesk2.arhs-developments.com/browse/BMWVID-14770
 */
const listener = event => {
  if (event.persisted) {
    window.location.reload();
  }
};

window.addEventListener('pageshow', listener);
